app.controller('popupSickLeaveController', ['$scope', '$state', '$mdDialog', '$timeout', 'objectHelper', 'baseModel',
    'applicationModel', 'sickLeaveModel', 'sickLeave', 'mainDiagnosis', 'visit', 'previewOnly',
    function ($scope, $state, $mdDialog, $timeout, objectHelper, baseModel, applicationModel, sickLeaveModel, sickLeave,
              mainDiagnosis, visit, previewOnly) {


        function setData() {
            $scope.forms =  {
                sickLeave: null
            };
            if(sickLeave) {
                $scope.sickLeave = angular.copy(sickLeave);
            } else {
                $scope.sickLeave = new SickLeaveVO();
                $scope.sickLeave.icd10 = mainDiagnosis.icd10;
                $scope.sickLeave.issueDate = new Date(); // fixme should be filled on backend
                $scope.sickLeave.visitCard = new VisitCardVO(visit.visitCard.id);
            }

            $scope.isPreview = previewOnly;
        }

        function setPermissions() {
        }

        function setListeners() {

        }

        function setActions() {
            $scope.save = function(print) {
                $scope.forms.sickLeave.$setSubmitted();
                if($scope.forms.sickLeave.$valid) {
                    if($scope.sickLeave.id) {
                        sickLeaveModel.update($scope.sickLeave).then(function(ref) {
                            checkForDownload(ref);
                        })

                    } else {
                        sickLeaveModel.save($scope.sickLeave).then(function(ref) {
                            checkForDownload(ref);
                        });
                    }
                }


                function checkForDownload(obj) {
                    if(print) {
                        $scope.previewOnly = true;
                        sickLeaveModel.downloadPDF(obj.id).then(function(link) {
                            window.open(link, '_blank');
                            window.focus();
                            $mdDialog.hide(obj);
                        })
                    } else {
                        $mdDialog.hide(obj);
                    }
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };


        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);